import _t from 'i18n!nls/enterprise-admin-home';

export const getSortByOptions = () => [
  { value: 'CREATED', label: _t('Date created') },
  { value: 'NAME', label: _t('Alphabetically') },
  // TODO BE calls are too expensive
  // { value: 'JOINED', label: _t('Number of learners joined') },
  // { value: 'INVITED', label: _t('Number of learners invited') },
];

export type ProgramSort = 'CREATED' | 'NAME';

export const getShowResultsOptions = () => [
  { value: 'ASC', label: _t('Ascending') },
  { value: 'DESC', label: _t('Descending') },
];

export type ProgramOrder = 'ASC' | 'DESC';
